import React, { useCallback, useEffect, useState } from "react";

import classnames from "classnames";

import _DatePicker, {
  DatePickerProps as _DatePickerProps,
} from "react-date-picker";
import "./DatePicker.css";

import { useIntl } from "react-intl";
/**
 * FIXME: Should come from it's own file
 */
import { ReactHookFormProps } from "../Select";

import { useWombatTheme } from "../../../theme";

type DatePickerProps = Omit<_DatePickerProps, "locale"> & {
  label?: string;
  defaultValue?: Date;
  RHF?: ReactHookFormProps;
};

const DatePicker: React.FC<DatePickerProps> = ({
  RHF,
  label,
  defaultValue,
  onChange,
  disabled,
  ...props
}) => {
  const { theme } = useWombatTheme();
  const [dateValue, setDateValue] = useState<Date>(defaultValue);
  const { locale } = useIntl();

  useEffect(() => {
    if (RHF) {
      RHF.register(RHF.name, RHF.registerOptions);
      return () => RHF?.unregister?.(RHF.name);
    }
  }, [RHF?.register, RHF?.unregister, RHF?.name]);

  useEffect(() => {
    if (RHF) RHF.setValue(RHF.name, defaultValue, RHF.setValueOptions);
  }, [defaultValue]);

  const _onChange = useCallback(
    (value: Date) => {
      setDateValue(value);
      if (onChange) onChange(value);
      if (RHF) {
        RHF.setValue(RHF.name, value, RHF.setValueOptions);
      }
    },
    [RHF?.setValue, onChange]
  );

  const labelStyle = classnames(
    theme.form.input.label.base,
    disabled ? theme.form.input.label.disabled : theme.form.input.label.able
  );

  return (
    <label>
      {label && <span className={labelStyle}>{label}</span>}
      <_DatePicker
        {...props}
        disabled={disabled}
        locale={locale}
        value={dateValue}
        defaultValue={defaultValue}
        onChange={_onChange}
      />
    </label>
  );
};

export default React.memo(DatePicker);
